import { Lisio } from "../../lisio";

function lisioDisableAllMessageHandler(this: Lisio) {
  this.setDefault(false, true);
}

export { lisioDisableAllMessageHandler };
